import { ParseToNumber } from "./tools"
import { NumberFormatToNode } from './../../../global';

class Mapping {
    constructor(mapping = new String, props = new Array ){
      if(mapping){
        this.mapping = mapping
        this.value = -9999

        let prop = props.find(p => p.mapping == this.mapping)
        if(prop){
          this.value = ParseToNumber(prop.value)
        }
      }
    }
  }
  
  function ToWrite(mappings = Array, method = new String, props = new Array){
    for(let m of mappings){
      let sameProps = props.filter(p => p.mapping == m.mapping)
      if(sameProps.length > 0){
        let value = NumberFormatToNode(m.value);
        sameProps.forEach(p => p.value = value)
      }
    }
    console.log(`${method} [Executado com sucesso!]` )
  }

export {
    Mapping,
    ToWrite
}